import "./Separator.css";

export const Separator = () => {
  return <div className="Separator" />;
};

